import React, { useState } from 'react';
import { useStoreConfigContext, useWishListsContext } from '/src/providers';
import { Form, useConfirmation } from '/src/components';
import Edit from './Edit';
import * as styles from './styles.scss';

const Item = ({
    wishListId,
    sku,
    name,
    visibility,
    wishListItemId,
    handleError,
    isDeleteWishList = true,
    isEditWishList = true,
    children,
}) => {
    const {
        isLoadingWishLists,
        updateWishList,
        deleteWishList,
        addProductsToWishList,
        removeProductsFromWishList,
        WISH_LIST_STATUSES,
    } = useWishListsContext();
    const { toggleConfirmation, Confirmation } = useConfirmation();
    const { translate } = useStoreConfigContext();
    const [isEdit, setIsEdit] = useState(false);

    const handleToggle  = () => setIsEdit(!isEdit);

    const handleUpdateWishList = ({ visibility, ...variables}) => handleError(updateWishList({
        ...variables,
        visibility: visibility ? WISH_LIST_STATUSES.PRIVATE : WISH_LIST_STATUSES.PUBLIC
    })).then(response => {
        handleToggle();

        return response;
    });

    const handleDeleteWishList = () => handleError(deleteWishList({ wishlistId: wishListId }));

    const handleAddProductsToWishList = (sku, wishListId) => handleError(addProductsToWishList({
        wishlistId: wishListId,
        wishlistItems: [{ sku, quantity: 1 }]
    }));

    const handleRemoveProductsFromWishList = (itemId, wishListId) => handleError(removeProductsFromWishList({
        wishlistId: wishListId,
        wishlistItemsIds: [itemId]
    }));

    return (
        isEdit
        ?
        <Edit
            wishListId={wishListId}
            name={name}
            visibility={visibility}
            handleUpdateWishList={handleUpdateWishList}
            isLoadingWishLists={isLoadingWishLists}
        >
            {
                isDeleteWishList &&
                <button
                    className={`${styles.button} ${styles.delete}`}
                    aria-label="Delete wishlist"
                    title="Delete"
                    onClick={() => toggleConfirmation({[wishListId]: true})}
                    disabled={isLoadingWishLists}
                >
                    <span>{translate('Delete')}</span>
                </button>
            }
            <button
                className={`${styles.button} ${styles.close}`}
                aria-label="Close wishlist"
                title="Close"
                onClick={handleToggle}
                disabled={isLoadingWishLists}
            >
                <span>{translate('Close')}</span>
            </button>
            <Confirmation
                id={wishListId}
                onSuccess={handleDeleteWishList}
                disabled={isLoadingWishLists}
            />
        </Edit>
        :
        <div className={styles.item}>
            {
                sku &&
                <Form.Checkbox
                    id={wishListId}
                    key="visibility"
                    type="checkbox"
                    name="toWishlist"
                    checked={!!wishListItemId}
                    onChange={
                        () => !!wishListItemId
                            ? handleRemoveProductsFromWishList(wishListItemId, wishListId)
                            : handleAddProductsToWishList(sku, wishListId)
                    }
                />
            }
            <div
                className={`${styles.visibility} ${visibility ? styles.private : styles.public}`}
            />
            <label
                htmlFor={wishListId}
                className={styles.name}
            >
                <span>{name}</span>
                {children}
            </label>
            {
                isEditWishList &&
                <button
                    className={`${styles.link}`}
                    aria-label="Edit Wishlist"
                    title="Edit"
                    onClick={() => setIsEdit(!isEdit)}
                >
                    <span>{translate('Edit')}</span>
                </button>
            }
        </div>
    );
};

export default Item;
